__turbopack_context__.v({
  "bannerBg": "z_N9Fa_bannerBg",
  "referFriendBg": "z_N9Fa_referFriendBg",
});
